
import { Booking } from "@/api/dtos/Booking.schema";
import { BookingDetails } from "@/api/dtos/BookingDetails.schema";
import { rentalStatusToGerman } from "@/misc/i18n";
import { BookingsModule } from "@/store/modules/BookingsModule";
import moment from "moment";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ContainerFrame from "../ContainerFrame.vue";
import DateRangePicker from "../DateRangePicker.vue";
import BookingDetailsDialog from "./BookingDetailsDialog.vue";
import {
  formatBookingDateTime,
  hasBookingTimeZone,
} from "@/utils/bookingDateFormatter";

@Component({
  components: {
    ContainerFrame,
    BookingDetailsDialog,
    DateRangePicker,
  },
})
export default class BookingsTable extends Vue {
  @Prop({
    default: 110,
  })
  width!: number;

  @Prop({
    default: 30,
  })
  height!: number;

  clickedBooking: BookingDetails | null = null;
  showDetailsDialog = false;
  searchQuery = "";
  dateRange: [Date, Date] | [Date] = [
    moment().subtract(7, "day").toDate(),
    moment().toDate(),
  ];

  rentalStatusToGerman = rentalStatusToGerman;
  moment = moment;
  formatBookingDateTime = formatBookingDateTime;
  hasBookingTimeZone = hasBookingTimeZone;

  async mounted(): Promise<void> {
    const openedQueryBooking = await this.openBookingFromQuery();

    if (!openedQueryBooking) {
      await this.fetchBookingsForDateRange();
    }
    const query = this.$route.query as { [k: string]: string };
    // TODO evaluate query params
    // if (!query) return
    // if (query.booking) {
    //   this.queryBooking = query.booking
    // }
    // if (query.dates) {
    //   this.queryDates = this.stringToArray(query.dates)
    // }
    // TODO consider station filter
    // if (query.stations) {
    //   this.queryStations = this.stringToArray(query.stations)
    // }
  }

  onDateRangeChanged(dateRange: [Date, Date] | [Date]): void {
    this.dateRange = dateRange;
    this.fetchBookingsForDateRange();
  }

  @Watch("$route.query.booking")
  async onBookingQueryChanged(): Promise<void> {
    await this.openBookingFromQuery();
  }

  readonly headers: {
    text: string;
    value: string;
    align?: "start" | "center" | "end";
  }[] = [
    {
      text: "Buchungs-ID",
      value: "bookingId",
    },
    {
      text: "Station",
      value: "stationName",
    },
    {
      text: "Nutzer",
      value: "user.email",
    },
    {
      text: "Box",
      value: "device",
    },
    {
      text: "von",
      value: "start",
    },
    {
      text: "bis",
      value: "end",
    },
    {
      text: "Status",
      value: "status",
    },
    {
      text: "",
      value: "actions",
      align: "center",
    },
  ];

  get bookings(): Booking[] {
    return BookingsModule.bookings;
  }

  get clickedBookingDetails(): BookingDetails | null {
    return BookingsModule.detailedBooking;
  }

  onRowClicked(booking: Booking): void {
    console.log(booking);
    BookingsModule.fetchDetailedBooking(booking.bookingId);
    this.showDetailsDialog = true;
  }

  private async openBookingFromQuery(): Promise<boolean> {
    const bookingId = this.$route.query.booking;

    if (typeof bookingId !== "string" || !bookingId) {
      return false;
    }

    await BookingsModule.fetchDetailedBooking(bookingId);

    if (BookingsModule.detailedBooking) {
      this.dateRange = [
        moment(BookingsModule.detailedBooking.start).startOf("day").toDate(),
        moment(BookingsModule.detailedBooking.end).endOf("day").toDate(),
      ];

      await this.fetchBookingsForDateRange();
    }

    this.searchQuery = bookingId;
    this.showDetailsDialog = true;
    return true;
  }

  private async fetchBookingsForDateRange(): Promise<void> {
    await BookingsModule.fetchBookings({
      start: this.dateRange[0],
      end: this.dateRange[1] ?? new Date(),
    });
  }
}
